// src/pages/ForumPage.jsx
import React, { useEffect, useState } from 'react';
import QuestionCard from './QuestionCard';
import AskQuestionForm from './AskQuestionForm';
import {ReactComponent as LoungePic} from '../../../assets/images/lounge_1.svg';
import { useUser } from "../../store/UserContext";
import axios from 'axios';

const ForumPage = () => {
  const {user} = useUser();
  const [conductOpen, setConductOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [forumList, setForumList] = useState([]);
  const [error, setError] = useState('');
  const buttonClass = `mr-4 p-1 
                        bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                        border-2 rounded-lg 
                        text-base font-bold tracking-widest normal-case`;
  
  const handleAddQuestion = (newQuestion) => {
    setForumList([{ ...newQuestion, id: Date.now() }, ...forumList]);
    setShowForm(false);
  };
  
  
  useEffect(() => {
    // Define an async function inside useEffect
    const fetchForumList = async () => {
      try {
        const response = await axios.get('/api/queries/');
        setForumList(response.data);
      } catch (err) {
        // Handle error by setting the error state
        console.error("Error fetching forum list:", err);
        setError('Sorry, the Lounge has failed to load. Please try again later.');
      }
        
    };
    fetchForumList();
  },[]);
  useEffect(() => {
    console.log('showForm changed:', showForm);
  }, [showForm]);
  console.log(forumList)
  return (
    <div>
      {/* Upper Green Welcome Section */}
      <div className="flex flex-row max-h-72 justify-between bg-gradient-to-r from-primary-100 to-primary-200 border border-primary-300 rounded-xl p-6 shadow-md m-4">
        <div className="flex flex-col w-1/2 text-center align-middle justify-center">
            <h1 className="text-2xl md:text-3xl font-bold text-primary-900 mt-8 mb-2 font-sans tracking-wider">
              Welcome to
            </h1>
            <h1 className="text-2xl md:text-3xl font-bold text-primary-900 mb-2 font-sans tracking-wider">
              The Admissions Lounge!
            </h1>
            <p className="text-gray-700 mb-4 text-sm md:text-base m-1 p-2">
              Ask questions, share insights, and help others. Whether you’re preparing for CET, exploring colleges, or diving into careers in engineering, this space is for you.
            </p>
        </div>
        <div className="flex flex-col relative w-1/2 overflow-y-visible">
            <div className="inset-0 items-center justify-center">
                <LoungePic className="max-h-52 w-full object-contain text-green-500"/>
            </div>
            <div className="text-xs text-end">
                <a href="http://www.freepik.com" >@Image Credits: Designed by pch.vector / Freepik</a>
            </div>
        </div>
      </div>
      <div className="ml-6">
          <h2 onClick={()=> setConductOpen(!conductOpen)} className="text-sm font-semibold text-orange-600 cursor-pointer" >Read our Code of Conduct 📜</h2>
          {conductOpen && (
          <div className="text-sm m-4">
              <p>
                We would like every member to feel welcome and participate, regardless of their level of expertise or identity. 
                We expect everyone to be a respectful, professional and kind to others. 
              </p>
              <div className="mt-4 mb-4">
                  <p>
                    Apart from that,
                  </p>
                  <ul className="ml-4">
                    <li> - No spam, self-promotion, or inappropriate language.</li>
                    <li> - Use the forum for relevant discussions only.</li>
                    <li> - Report any in-appropriate content immediately.</li>
                  </ul>
              </div>
              <p>
                  Members indulging in any of the above activities will be barred from making any contributions.
              </p>
          </div>
          )}
      </div>
      {/* Recent Discussion and Ask a Question Section */}
      <div className="flex flex-row justify-between items-start align-middle m-2">
          {/* Left side - Text Recent Discussions */}
          <div className="flex items-center">
              <h1 className="text-2xl font-bold text-primary-900 ml-4 font-nunito tracking-wider whitespace-nowrap">Recent Discussions</h1>
          </div>
          {/* Right Side: Ask Question & code of conduct only for members*/}
          {user && (
            <>
            <div className="flex flex-col justify-end items-end align-middle w-1/3">
              {!showForm && (
                <div className="flex">
                      <button
                        onClick={() => setShowForm(true)}
                        className={`${buttonClass}`}
                      >
                        + Ask a Question
                      </button>
                </div>
              )}
              
              
            </div>
            
          </>
          
        )}      
      </div>

      {showForm && (
              <div className="w-full p-4 m-4">
                  <AskQuestionForm
                    onSubmit={handleAddQuestion}
                    onCancel={() => setShowForm(false)}
                  />
              </div>
          )}
      
      {/* List of Questions */}
      {error && <div className="text-danger-500 text-lg text-center">{error}</div>}
      <div className="flex p-2 gap-4">
        <div className="flex-1 space-y-4">
          {console.log(forumList)}
          {forumList.map((q) => (
            <QuestionCard key={q.id} question={q} />
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default ForumPage;
